import { Component } from '@verndale/core';

class MobileHeader extends Component {
  setupDefaults() {
    this.dom = {
      navBtn: this.el.querySelector('.mobile-header__menu-container button'),
      navOpenIcon: this.el.querySelector(
        '.mobile-header__menu-button__icon-open'
      ),
      navCloseIcon: this.el.querySelector(
        '.mobile-header__menu-button__icon-close'
      ),
      navContainer: this.el.querySelector('.mobile-header__nav-container'),
      searchContainer: this.el.querySelector(
        '.mobile-header__search-button .mobile-header__nav-container'
      ),
      cartBtn: this.el.querySelector('.mobile-header__cart-button button'),
      cartContainer: document.querySelector(
        '.cart__container'
      ),
      closeCartBtn: document.querySelector(
        '.cart__item__close-button'
      ),
      keepBrowsingBtn: document.querySelector('.cart__view-basket-button--keep-browsing'),
      subMenuBtns: this.el.querySelectorAll('.has-submenu'),
      mainMenu: this.el.querySelector('.mobile-header__nav__main-nav'),
      allSubMenus: this.el.querySelectorAll(
        '.mobile-header__nav__submenu-container'
      ),
      backBtns: this.el.querySelectorAll('.mobile-header__nav__back-button'),
      accordionBtns: this.el.querySelectorAll(
        '.mobile-header__nav__submenu-item__accordion-button'
      )
    };
  }

  addListeners() {
    const {
      navBtn,
      cartBtn,
      subMenuBtns,
      backBtns,
      accordionBtns,
      closeCartBtn,
      keepBrowsingBtn
    } = this.dom;

    navBtn.addEventListener('click', this.toggleNav.bind(this));
    cartBtn.addEventListener('click', this.toggleCart.bind(this));
    closeCartBtn.addEventListener('click', this.closeCartNav.bind(this));
    if (keepBrowsingBtn) {
      keepBrowsingBtn.addEventListener('click', this.closeCartNav.bind(this));
    }

    subMenuBtns.forEach(btn => {
      btn.addEventListener('click', this.toggleSubMenu.bind(this));
    });

    backBtns.forEach(btn => {
      btn.addEventListener('click', this.toggleBack.bind(this));
    });

    accordionBtns.forEach(btn => {
      btn.addEventListener('click', this.toggleAccordion.bind(this));
    });
  }

  lockBody() {
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.overflowY = 'scroll';
  }

  unlockBody() {
    document.body.removeAttribute('style');
  }

  closeCartNav() {
    this.dom.cartContainer.setAttribute('hidden', true);
    this.dom.cartBtn.classList.remove('is-active');
    this.unlockBody();
  }

  toggleAccordion(el) {
    const button = el.target.closest('button');
    const ariaControls = button.getAttribute('aria-controls');
    const accordionContent = document.getElementById(ariaControls);
    const minusIcon = button.querySelector('.minus-icon');
    const plusIcon = button.querySelector('.plus-icon');

    if (accordionContent.hidden) {
      accordionContent.removeAttribute('hidden');
      minusIcon.removeAttribute('hidden');
      plusIcon.setAttribute('hidden', true);
    } else {
      accordionContent.setAttribute('hidden', true);
      minusIcon.setAttribute('hidden', true);
      plusIcon.removeAttribute('hidden');
    }
  }

  toggleBack(el) {
    const button = el.target.closest('button');
    const ariaControls = button.getAttribute('aria-controls');
    const subMenu = document.getElementById(ariaControls);

    this.hideAllMenus();
    if (subMenu.hidden) {
      subMenu.removeAttribute('hidden');
    } else {
      subMenu.setAttribute('hidden', true);
    }
  }

  toggleSubMenu(el) {
    const link = el.target.closest('a');
    const ariaControls = link.getAttribute('aria-controls');
    const subMenu = document.getElementById(ariaControls);

    this.hideAllMenus();
    if (subMenu.hidden) {
      subMenu.removeAttribute('hidden');
    } else {
      subMenu.setAttribute('hidden', true);
    }
  }

  hideAllMenus() {
    this.dom.mainMenu.setAttribute('hidden', true);
    this.dom.allSubMenus.forEach(menu => {
      menu.setAttribute('hidden', true);
    });
  }

  toggleNav(el) {
    const button = el.target.closest('button');
    this.hideMainNavs(button);
    this.dom.navBtn.classList.toggle('is-active');
    if (this.dom.navContainer.hidden) {
      this.dom.navOpenIcon.setAttribute('hidden', true);
      this.dom.navCloseIcon.removeAttribute('hidden');
      this.dom.navContainer.removeAttribute('hidden');
      this.lockBody();
    } else {
      this.dom.navOpenIcon.removeAttribute('hidden');
      this.dom.navCloseIcon.setAttribute('hidden', true);
      this.dom.navContainer.setAttribute('hidden', true);
      this.unlockBody();
    }
  }

  toggleCart(el) {
    const button = el.target.closest('button');
    this.hideMainNavs(button);
    this.dom.cartBtn.classList.toggle('is-active');
    if (this.dom.cartContainer.hidden) {
      this.dom.cartContainer.removeAttribute('hidden');
      this.lockBody();
    } else {
      this.dom.cartContainer.setAttribute('hidden', true);
      this.unlockBody();
    }
  }

  hideMainNavs(button) {
    // closing main nav
    if (button !== this.dom.navBtn) {
      this.dom.navBtn.classList.remove('is-active');
      this.dom.navOpenIcon.removeAttribute('hidden');
      this.dom.navCloseIcon.setAttribute('hidden', true);
      this.dom.navContainer.setAttribute('hidden', true);
    }
    // closing cart nav
    if (button !== this.dom.cartBtn) {
      this.dom.cartBtn.classList.remove('is-active');
      this.dom.cartContainer.setAttribute('hidden', true);
    }
  }
}

export default MobileHeader;
